import Field, {
  FieldApparence,
  FieldValidation
} from "../../../components/simpleCrud/field.class";
import SCTranslations from "../../../components/simpleCrud/SCTranslations.class";

"use strict";
// @flow
const angular = require("angular");

interface Configs {
  name: string;
  email: string;
  role: string;
  password: string;
}

export default class ConfigurationsController {
  configs;
  config: Configs;
  service;
  fields = [
    new Field("name", "text"),
    new Field("fileMonthlyCashDesk", "file", {
      apparence: new FieldApparence({ fullwidth: true }),
      validation: new FieldValidation({ required: false })
    }),
    new Field("fileMonthlySelling", "file", {
      apparence: new FieldApparence({ fullwidth: true }),
      validation: new FieldValidation({ required: false })
    }),
    new Field("active", "checkbox", {
      apparence: new FieldApparence({ fullwidth: false, isNarrow: true }),
      validation: new FieldValidation({ required: false })
    })
  ];

  translations: SCTranslations = new SCTranslations({
    listTitle: "LBL_CONFIGURATIONS",
    listIsEmpty: "LBL_NO_CONFIGURATIONS_FOUND",
    newTitleNoData: "LBL_FIRST_NEW_CONFIGURATION"
  });
  /*@ngInject*/
  constructor(private Configurations) {
    this.service = Configurations;
  }
  save(form) {}
}



// WEBPACK FOOTER //
// ./client/app/admin/configurations/configurations.controller.ts